import React, { useState, useRef, useEffect } from "react";
import styles from "./BaseSelectCustom.module.scss";
import classNames from "classnames/bind";
import { ArrowDownBlackIcon } from "~/assets/icons";

const cx = classNames.bind(styles);

type ViewOption = {
  id: string | number;
  label: string;
  disabled?: boolean;
};

type BaseSelectV2Props = {
  viewOptions?: ViewOption[];
  selectedView: string | number | null;
  onViewChange: (viewId: string | number | null) => void;
  className?: string;
  placeholder?: string;
  IconDrop ?: JSX.Element;
  minWidth? :string;
  isViewMode?:boolean;
  isViewNoInput?:boolean;
  height?:string,
  error?:string,
  textAlign?:string,
  showCheckmark?: boolean;
  bgDropdown?:string;
};

const BaseSelectCustom: React.FC<BaseSelectV2Props> = ({
  viewOptions = [],
  selectedView,
  onViewChange,
  className = "",
  placeholder,
  minWidth,
  IconDrop,
  isViewMode,
  isViewNoInput,
  error,
  textAlign="",
  height,
  showCheckmark = true,
  bgDropdown,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const selectRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!isOpen) return;
    const handleClickOutside = (event: MouseEvent) => {
      if (
        selectRef.current &&
        !selectRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  const currentView =
    viewOptions.find((view) => view.id === selectedView) ||
    (placeholder ? { id: null, label: placeholder } : null);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const selectView = (viewId: string | number | null, disabled?: boolean) => {
    if (disabled) return;
    onViewChange(viewId);
    setIsOpen(false);
  };

  if (!currentView) {
    return null;
  }

  return (
    <div ref={selectRef} className={cx("container", className)}>
      <button onClick={toggleDropdown} className={cx("main-button", "main-button-custom")} style={{
        minWidth: minWidth,
        height: height ? height : "100%",

        border: isViewMode && isViewNoInput? "0px":undefined,
        paddingLeft: isViewMode && isViewNoInput? "0px":undefined,
        background: isViewMode &&  isViewNoInput? "transparent !important":"red",
        pointerEvents: isViewMode &&  isViewNoInput? "none":undefined,
      }}>
        <span className={cx("main-label")}>{currentView.label}</span>
        {
          isViewMode ? <></> : IconDrop ? IconDrop : <ArrowDownBlackIcon
            className={cx("icon", { "icon-open": isOpen })}
          />
        }

      </button>
      {error && <p className={cx("error-message")}>{error}</p>}
      {!isViewMode && isOpen && (
        <>
          <div
            className={cx("dropdown-backdrop")}
            onClick={() => setIsOpen(false)}
          />
          <div className={cx("dropdown")}>
            {placeholder && (
              <button
                key="placeholder"
                onClick={() => selectView(null)}
                className={cx("dropdown-item", {
                  selected: selectedView === null,
                })}
              >
                <span>{placeholder}</span>
                {showCheckmark && selectedView === null && (
                  <div className={cx("selected-dot")} />
                )}
              </button>
            )}
            {viewOptions.map((option) => {
              const isSelected = option.id === selectedView;
              const isDisabled = !!option.disabled;
              return (
                <button
                  key={option.id}
                  type="button"
                  disabled={isDisabled}
                  onClick={() => selectView(option.id, isDisabled)}
                  className={cx({
                    "dropdown-item": true,
                    'text-left': textAlign == 'left',
                    'text-center': textAlign == 'center',
                    'text-right': textAlign == 'right',
                    selected: isSelected,
                    disabled: isDisabled,
                  })}
                  style={{
                    background: bgDropdown ?? ""
                  }}
                >
                  <span>{option.label}</span>
                  {showCheckmark && isSelected && <div className={cx("selected-dot")}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M18 7L9.75 16L6 11.9091" stroke="#1CA78B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </div>
                  }
                </button>
              );
            })}
          </div>
        </>
      )}


    </div>
  );
};

export default BaseSelectCustom;
